import { useState, useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";
import PinkEye from "../../components/assets/eyes/PinkEye";
import YellowEye from "../../components/assets/eyes/YellowEye";
import { Link } from "react-router-dom";
import BlueButton from "../../components/buttons/BlueButton";
import ArrowUpRight from "../../components/icons/ArrowUpRight";
import ArrowBis from "../../components/assets/ArrowBis";
import DoubleArrowBackground from "../DoubleArrowBackground";
export default function OurStory() {
    return (
        <div className="mt-[8rem]">
            <div className="flex justify-center items-center gap-[9.125rem] tablet:w-fit tablet:mx-auto tablet:relative tablet:pt-40 tablet:max-w-[300px]">
                <div className="w-[16.875rem] aspect-square tablet:absolute tablet:w-[10rem] tablet:top-0 tablet:left-1/2 tablet:-translate-x-[125%]">
                    <PinkEye />
                </div>
                <div className="flex flex-col">
                    <h2 className="text-big-heading tablet:text-[7rem] mobile:text-[5rem] font-[800] whitespace-nowrap text-center">
                        Notre Story
                    </h2>
                    <p className="text-large font-bold text-center tablet:text-heading-5">
                        Un parcours assez classique en vrai rien de fou (quoi que)
                    </p>
                </div>
                <div className="w-[16.875rem] aspect-square tablet:absolute tablet:w-[10rem] tablet:top-0 tablet:left-1/2 tablet:translate-x-1/4">
                    <YellowEye version={3}/>
                </div>
            </div>
            <DoubleArrowBackground>
                <Link to={"/about"}>
                    <BlueButton icon={<ArrowUpRight />} className={"scale-[1.5] tablet:scale-[1] tablet:w-[300px]"}>
                        Je vais zoeiter ça
                    </BlueButton>
                </Link>
            </DoubleArrowBackground>
        </div>
    )
}